<template lang="pug">
.doHEADLINE
  div {{cont.title}}
</template>
<script>
export default {
  props: ["cont"],
  created() {
    console.log(this.cont);
  }
};
</script>
<style lang="stylus" scoped>
.doHEADLINE
  width 100%
  font-size 16px
  font-family MicrosoftYaHeiUI
  color rgba(42, 46, 54, 1)
  line-height 20px
  line-height 25px
</style>
